<template>
  <!-- If card is empty, show a add button -->
  <el-card class="item">
    <el-button
      class="item--empty"
      @click="$router.push(`submission`)"
    >
      <i class="el-icon-plus" style="font-size: 3em;"></i>
      <p>Add a new film</p>

    </el-button>
  </el-card>
</template>

<script>
export default {};
</script>

<style lang="scss">
.item--empty {
  position: absolute;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ListItemAddButton.vue